<template>

    <b-modal  id="CategoryModal" 
      v-model="showCategoryModal" 
      size="xl" 
      centered 
      hide-footer
      hide-header
      no-close-on-backdrop
      @hide="closeWin">
        <b-overlay :show="isLoading">
             <div class="category-modal-container">
        <div class="category-modal-header">
          <div class="category-modal-header-content">
            <div class="category-modal-title">
              <div class="category-title-text">
                <!-- <img :src="`${this.cdnUrl}/2-0/icons/SearchCriterionIcons/Categories.svg`"> -->
                {{$t('lbl_EMPBE_PleaseSelect')+$t('Lbl_ProdCats')}}</div>
            </div>
            <div class="category-search-box">
              <div class="category-search-content">
                <i class="fa fa-search category-search-icon" style="font-size: 20px;" aria-hidden="true" ></i>
                <!-- <div class="category-search-icon"></div>
                <div class="category-search-text">Search</div> -->
              <input type="text"  v-model="searchKeyword" autocomplete="off" :placeholder="$t('lbl_EMPBE_Search')" class="txtSearch">   
               
              </div>
            </div>
            <div class="category-close-btn" @click="closeWin">
              <!-- <div class="category-close-icon"></div> -->
               <img src="https://cdn.adsalecdn.com/EMP/2-0/icons/Black-Close.svg?version=20250909_1635">
            </div>
          </div>
        </div>
        
      <div class="category-modal-body row" style="margin-right:0;margin-left:0;">  
        <div v-if="searchKeyword.trim()==''" v-for="level in getNumberOfLayer" :class="`col-`+(level==1?'3':level==2?'4':'5')" 
          class="itemCol"    style="">
          <div  :level="level" v-for="dataObj in getDataOnLevel(level)" :class="`category-modal-`+getItemClass(level)">
              <div :class="`category-`+getItemClass(level)+`-item`+(selectItem(level,dataObj.id)?` item-active`:``)"  @mouseenter="onMouseHover(level,dataObj)">
                <!--level 1 -->
                <div class="category-item-content" v-if="level==1">
                  <div class="category-item-icon" v-if="dataObj.id!=997&&dataObj.id!=360">
                    <img  :src="getCategoryIcon(dataObj.id)" />
                  </div>
                  <div class="category-item-text" :subid="dataObj.id">{{dataObj.text}}
                    <span v-if="dataObj.compSelectedStatus==1" class="selectedInComp">
                    
                    </span>
                    </div>
                </div>
                <!--end level1-->
                <!--复选框-->
                <input v-if="level==3" :checked="isChecked(dataObj.id)" :disabled="isDisabled(dataObj.id)" @change="onCheckboxChange($event, dataObj)"   :id="`VueCheckbox_Categories_`+dataObj.id" name="VueCheckbox_Categories"  class="category-checkbox" type="checkbox" />
                <!--文字-->
                <label v-if="level!=1" :for="`VueCheckbox_Categories_`+dataObj.id" :class="`category-`+getItemClass(level)+`-text`" style="margin-bottom:0" >{{dataObj.text}}
                </label> 
                  <IconHoverTipsText  style="display: inline-block; vertical-align: middle;" v-if="dataObj.compSelectedStatus==1" :id="'selectedHoverTip_'+dataObj.id" :placement="`top`"
                      :Title="$t('lbl_EMPBE_SelectedinCompTip')" :IconUrl="`${cdnUrl}/Backend/svg/ProductInfo/home_work.svg`">
                      <template v-slot:Text> 
                      </template>
                  </IconHoverTipsText>
                  <img :src="getArrowIcon" v-if="level!=3" class="Go_Icon">  <!--箭头-->
                </div>
          </div> 
       </div> 
        <div  v-if="searchKeyword.trim()!=''" class="col-12"  style="overflow-y: auto;max-height: 521px;scrollbar-color: #8C8B99 #eee;  scrollbar-width: thin;">
          <div  level="3" v-for="dataObj in getSearchedData" class="category-modal-right">
              <div class="category-right-item" > 
                <!--复选框-->
                <input :id="`VueCheckbox_Categories_`+dataObj.id" :checked="isChecked(dataObj.id)" :disabled="isDisabled(dataObj.id)" @change="onCheckboxChange($event, dataObj)" name="VueCheckbox_Categories"   class="category-checkbox" type="checkbox" />
                <!--文字-->
                <label  :for="`VueCheckbox_Categories_`+dataObj.id" class="category-right-text" style="margin-bottom:0" >
                  {{dataObj.text}}
                <span v-if="dataObj.compSelectedStatus==1" class="selectedInComp">
                    <IconHoverTipsText  style="display: inline-block; vertical-align: middle;" v-if="dataObj.compSelectedStatus==1" :id="'search_selectedHoverTip_'+dataObj.id" :placement="`top`"
                      :Title="$t('lbl_EMPBE_SelectedinCompTip')" :IconUrl="`${cdnUrl}/Backend/svg/ProductInfo/home_work.svg`">
                      <template v-slot:Text> 
                      </template>
                  </IconHoverTipsText>
                </span>
                </label>                
              </div>              
          </div> 
        </div>
        </div> 
        <div class="category-modal-footer">
          <div v-if="companySelectedData&&companySelectedData.length>0">
            <img style="padding-right: 5px;" :src="`${cdnUrl}/Backend/svg/ProductInfo/home_work.svg`"> 
            {{$t('lbl_EMPBE_SelectedinCompTip')}}
          </div>
          <div class="category-confirm-btn" :class="tempSelectedItem.length==0?`confirm-btn-disable`:``" @click="confirmSelected">
            <div class="category-confirm-text">{{$t('lbl_confirm')}}</div>
          </div>
        </div>
     
      </div>
    </b-overlay>        
    </b-modal>

</template>


<script> 
import IconHoverTipsText from "../TipsAndPrivewDilog/CustomTooltip.vue"
  
export default {
  name: 'CatalogueModal',
   components: {
   IconHoverTipsText
  }, 
  props: ["showModal","checkListData","maxLength","companySelectedData","initSelectItems"],
  inject: {
    showDeleteConfirm: {
      // 默认提供三参数item,catType,isTrueDelete
      default: () => (_item, _catType, _isTrueDelete) => true
    }
  },
  data() {
    return {  
      searchKeyword: "", 
      isLoading: false, 
      cdnUrl:"https://cdn.adsalecdn.com/EMP" ,
      layedCheckBoxVersion:1, 
      showCategoryModal:false,  
      hoverItem:[],
      //initCategoryIds:[],
      tempSelectedItem:[],
      isProcessingCheckbox: false, // 防止复选框递归调用标志

    }
  },
  watch: {
      
  },
  mounted() {
     this.showCategoryModal = this.showModal; 
   
     //this.initCategoryIds=this.initSelectItems.map(item=>item.subId);
       console.log('initValues:'+this.initCategoryIds);  
      this.tempSelectedItem=this.initSelectItems;
     this.hoverItem=this.defaultHoverOnIds;
  },
  computed: {  
    isDelete(){
      console.log(this.isDeleteCat);
      return this.isDeleteCat;
    },
    initCategoryIds(){
      return this.initSelectItems.map(item=>item.subId.toString());
    },
    // 当前临时选中的分类ID列表（基于tempSelectedItem）
    tempSelectedIds(){
      if(this.tempSelectedItem)
      return this.tempSelectedItem.map(item=>item.subId.toString());
      return [];
    },
    defaultHoverOnIds(){
      var defauleSelectIds=[
       null,
      this.checkListData.find(x => x.id == 1),  //level 1
      this.checkListData.find(x=>x.id==2)];   //level 2
      return defauleSelectIds;

    },
    // selectedCategoryIds(){
    //   this.initSelectItems.map(item=>item.subId)
    // },
      //获取过滤之后的数据源，没有过滤返回原始数据
      getSearchedData(){   
        if(this.searchKeyword!=''&&this.searchKeyword.trim()!='' &&this.checkListData.length>0){
            
        const keyword = this.searchKeyword.toLowerCase().trim();
        const compSelectedIds = this.companySelectedData.map(x => x.id);
        const selectedIds=this.tempSelectedIds; // 使用临时选中的ID列表
        // 找到所有匹配的项目
        var dataListFilter=this.checkListData.filter(x =>x.level==3&&x.text.toLowerCase().includes(keyword) );
        var newdataList=dataListFilter.map(x => ({
                ... x,
                compSelectedStatus:compSelectedIds.includes(x.id.toString()) ? 1 : 0,
                selected:selectedIds.includes(x.id.toString()) ? true : false,
                newOrder:compSelectedIds.includes(x.id.toString())?0:x.orderId
                }) 
            ).sort((a, b) => {
            // 首先按 newOrder 排序
            if (a.newOrder !== b.newOrder) {
                return parseInt(a.newOrder) - parseInt(b.newOrder);
            }
            // 如果 newOrder 相同，再按 id 排序
            return parseInt(a.id) - parseInt(b.id);
        });
                
        if(newdataList.length === 0) {
            return [];
        }       
        return newdataList; 
        }else{
          return [];
        }
      }, 
     isAccordionShow() {
                return true
      },   
      isMobile() {
          return window.matchMedia('(max-width: 767px)').matches;
      },
      getNumberOfLayer() {
          //console.log(`TTTT : ${Math.min(this.state.expandedCriterion.length || 1, this.getMaxNumberOfLayer)}`)
          var MaxNumberOfLevel=this.getMaxNumberOfLayer;
          var number= Math.min(this.defaultHoverOnIds.length || 1, MaxNumberOfLevel);
          console.log('number'+number)
          return number;
      },
      getMaxNumberOfLayer() {
          if (!this.checkListData.length) {
              return 0
          }
          return Math.max(...this.checkListData.map(x => x.level));
      },
       getArrowIcon() {
                return `${this.cdnUrl}/2-0/BuyerIdx/gogogo.svg?version=${this.layedCheckBoxVersion}`;
      },
      getSearchIcon() {
          return `${this.cdnUrl}/2-0/icons/Search.svg?version=${this.layedCheckBoxVersion}`;
      },
      getClearSearchIcon() {
          return `${this.cdnUrl}/2-0/icons/Circle_Close.svg?version=${this.layedCheckBoxVersion}`;
      },
      getAccordionOpenIcon() {
          return `${this.cdnUrl}/2-0/icons/accordion/minus.svg?version=${this.layedCheckBoxVersion}`;
      },
      getAccordionCloseIcon() {
          return `${this.cdnUrl}/2-0/icons/accordion/plus.svg?version=${this.layedCheckBoxVersion}`;
      },
      compSelectedIds(){
        if(this.companySelectedData&&this.companySelectedData.length>0)
        return this.companySelectedData.map(x => x.id);
      else return [];
      },
      level1_selectedInCompIds(){ 
        if(this.level2_selectedInCompIds.length==0) return[]
       let leve1= this.checkListData.filter(x => this.level2_selectedInCompIds.includes(x.id.toString()))
                              .reduce((acc, x) => {
                                if (!acc.some(item => item.Id === x.parentId.toString())) {
                                  acc.push({ Id: x.parentId.toString() });
                                }
                                return acc;
                              }, []).map(x=>x.Id);
                              return leve1;
       },
      level2_selectedInCompIds(){ 
        if(this.compSelectedIds.length==0) return []
       let level2= this.checkListData.filter(x => this.compSelectedIds.includes(x.id.toString()))
                              .reduce((acc, x) => {
                                if (!acc.some(item => item.Id === x.parentId.toString())) {
                                  acc.push({ Id: x.parentId.toString() });
                                }
                                return acc;
                              }, []).map(x=>x.Id);
                              return level2;
       }
  },
  methods: {
    onMouseHover(level,item) {
        if (this.isMobile) {
            return
        }  
        if(level==3)
        return;

        if(this.showCategoryModal&&this.checkListData.length>0){
          let checkelist=this.checkListData;
          var dataLevel0=null;
          var dataLevel1=[];
          var dataLevel2=[];
 

          if(level==1)
          {  
           dataLevel1=item; 
           dataLevel2=checkelist.find(b => b.parentId == dataLevel1.id); 
          }else if(level==2){ 
           dataLevel1=checkelist.find(b => b.id == item.parentId); 
           dataLevel2=item;
          } 
          var SelectItem=[ dataLevel0, dataLevel1,dataLevel2]; 
          this.hoverItem=SelectItem;
      }
      
    }, 
    getItemClass(level) {
                //const numberOfLayer = this.getMaxNumberOfLayer
                let className=  level == 1?'sidebar':level == 2?'middle':'right';
                return className;
            },
    getDataOnLevel(level) {
      
      const origiData=this.checkListData;//this.getSearchedData();
      // 预处理公司已选分类，方便快速判断
        // const compSelectedIds = this.companySelectedData.map(x => x.id);

        if (level == 1) {
            
          let dataList= origiData.filter(x => x.level == level )
          .map(x => ({
                ... x, 
                compSelectedStatus:this.level1_selectedInCompIds.includes(x.id.toString())? 1 : 0,
                newOrder:this.level1_selectedInCompIds.includes(x.id.toString())?0:x.orderId
                }) 
            )
            .sort((a, b) => {
                  // 确保两个值都是数字
                const orderA = Number(a.newOrder !== undefined ? a.newOrder : a.orderId) || 0;
                const orderB = Number(b.newOrder !== undefined ? b.newOrder : b.orderId) || 0;
                return orderA - orderB;
              });
            return dataList;
        }
        else if(level > 1) {
          let defualtHoverItems=this.hoverItem.length>0?this.hoverItem:this.defaultHoverOnIds;//.length>0?this.selectedHoverOnIds:this.defaultHoverOnIds;
          let hadSelectedItem=this.tempSelectedIds; // 使用临时选中的ID列表
         

           let filterData_hoverItems = origiData.filter(x => x.level == level && x.parentId == defualtHoverItems[level - 1].id )//获取子类
           .map(x => ({
                ... x,
                selected: x.level == 3&&hadSelectedItem.includes(x.id.toString())?true:false,
                compSelectedStatus:level==2&&this.level2_selectedInCompIds.includes(x.id.toString())?1:level==3&&this.compSelectedIds.includes(x.id.toString()) ? 1 : 0,
                newOrder:this.level2_selectedInCompIds.includes(x.id.toString())||this.compSelectedIds.includes(x.id.toString())?0:x.orderId
                }) 
            ) .sort((a, b) => {
                  // 确保两个值都是数字
                const orderA = Number(a.newOrder !== undefined ? a.newOrder : a.orderId) || 0;
                const orderB = Number(b.newOrder !== undefined ? b.newOrder : b.orderId) || 0;
                return orderA - orderB;
              });
         
            return filterData_hoverItems
        }
        
    },   
      
    getCategoryIcon(Id) {
              return `${this.cdnUrl}/2-0/icons/Cat_ThumbNail/${Id}.png?version=${this.layedCheckBoxVersion}&x-oss-process=image/format,webp/resize,w_40,h_40`;
    },
    closeWin(){
      this.showCategoryModal=false;
      this.updateShowModal(false);
    },
    updateShowModal(value) { 
    // 更新父组件传递的 showModal prop
    this.$emit('update:showModal', value);
    },
    selectItem(level,thisCatId){
    if(this.hoverItem.length>0)
    {
      if(level>=1)
      {
        let seelctOjb=this.hoverItem[level];
        if(seelctOjb)
        return this.hoverItem[level].id==thisCatId;
          else 
          return false;
      }else 
      return false;

    }
    },
      // 判断复选框是否选中
    isChecked(categoryId) {
      return this.tempSelectedIds.includes(categoryId.toString());
    }, 
     // 判断复选框是否应该被禁用
     isDisabled(categoryId) {
       // 如果已选中，不禁用（允许取消选中）
       if (this.isChecked(categoryId)) {
         return false;
       }
       // 如果未选中，且已选中的数量达到最大值，则禁用
       return this.tempSelectedItem.length >= this.maxLength;
     },
     // 处理复选框变化事件
    async  onCheckboxChange(event, dataObj) {
      // 如果正在处理中，忽略此次调用，防止递归
      if (this.isProcessingCheckbox) {
        return;
      }
      
      console.log('onCheckboxChange');
       // 阻止默认行为，先进行验证
      event.preventDefault();
      
      // 设置处理标志，防止递归调用
      this.isProcessingCheckbox = true;
      
      try {
        const ishasChecked = event.target.checked;
        const categoryId = dataObj.id; 
        const node = {
           subId: categoryId,
           mainId: dataObj.parentId || null,
           text:dataObj.text,
           order:this.tempSelectedItem.length+1
         };
        let newTempArray = [...this.tempSelectedItem];
        if (ishasChecked) {  
          newTempArray.push(node);
          //this.tempSelectedItem.push(node); 
        } else {//删除操作
          // 先恢复选中状态，等待确认（此时 isProcessingCheckbox 为 true，不会触发递归）
          event.target.checked = true;
          //删除检验是否有广告           
          const isConfirmed = await this.showDeleteConfirm(node,null,false);
          if (isConfirmed) { 
            // 选中的项从选中列表移除 
            newTempArray = this.tempSelectedItem.filter(item => item.subId.toString() !== categoryId.toString()).map((item, index) => ({
                      ...item,
                      order: index + 1
                     }));
            // 使用 $nextTick 确保在下一个事件循环中设置，此时标志已重置，但因为是程序设置不会触发用户交互
            this.$nextTick(() => {
              if (event.target) {
                event.target.checked = false;
              }
            });
          } else {
            // 用户取消删除，保持选中状态（已经是 true，但为了确保状态正确）
            // 不需要设置，因为之前已经设置为 true
          }     
        } 
        this.tempSelectedItem = newTempArray;
      } finally {
        // 处理完成，重置标志（使用 $nextTick 确保在 DOM 更新后重置）
        this.$nextTick(() => {
          this.isProcessingCheckbox = false;
        });
      }
     },
      confirmSelected() {
      if(this.tempSelectedItem.length==0){
        //this.$Alert(0, this.$t("lbl_EMPBE_ProductCategory"));
        return ;
      }else{
       this.showCategoryModal=false;
       // 创建副本，避免引用问题
      const finalData = JSON.parse(JSON.stringify(this.tempSelectedItem));
       // 只有确认时才向父组件发送事件
        this.$emit('confirmSelected',finalData);
      }
      
     },
     
  }
}
</script>
<style lang="scss" scoped>
/* 产品类别选择模态框样式 */
#CategoryModal{
.modal-content{
    width: 1033px;
    height: 665px;
    border-radius: 16px;
    
}
}
.category-modal-container {
  width: 100%;
  height: 100%;
   
}

.category-modal-header {
  width: 100%;
  height: 72px;
  padding: 16px;
  background: #F9F9F9;
  border-bottom: 1px solid rgba(0, 0, 0, 0.10);
      border-top-right-radius: 16px;
    border-top-left-radius: 16px;
}

.category-modal-header-content {
  display: flex;
  align-items: center;
  gap: 24px;
}

.category-modal-title {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}
.itemCol{
  padding-right:0 !important;
  padding-left:0 !important;
  height: 100%;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  scrollbar-color: #8C8B99 #eee; /* 设置滚动条的颜色，第一个值为滑块颜色，第二个值为滚动条背景色 */
  scrollbar-width: thin; /* 设置滚动条的宽度 */
}
.selectedInComp{
    color: #4433FF;
    font-size: 14px;
    // font-family: Inter;
    font-weight: 700;
    line-height: 18.20px;
    word-wrap: break-word;
}
.category-title-text {
  color: rgba(0, 0, 0, 0.80);
  font-size: 16px;
  // font-family: Inter;
  font-weight: 700;
  line-height: 20.80px;
}

.category-search-box {
  //: 320px;
  height: 40px;
  padding: 4px 12px;
  background: white;
  border-radius: 100px;
  outline: 1.50px solid rgba(0, 0, 0, 0.10);
  outline-offset: -1.50px;
  display: flex;
  align-items: center;
}

.category-search-content {
  display: flex;
  align-items: center;
  height: 40px;
  // gap: 8px;
}
.txtSearch{ 
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: none;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    height: 38px;
    line-height: 40px;
    outline: 0;
    padding: 0 ;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 320px;
  // height: 38px;
}
.category-search-icon {
  width: 24px;
//   height: 24px;
  color: rgba(0, 0, 0, 0.60);
}

.category-search-text {
  color: rgba(0, 0, 0, 0.40);
  font-size: 14px;
  // font-family: Inter;
  font-weight: 400;
  line-height: 18.20px;
}

.category-close-btn {
  width: 24px;
  height: 24px;
  cursor: pointer;
  position: relative;
}

// .category-close-icon {
//   width: 14px;
//   height: 14px;
//   position: absolute;
//   left: 5px;
//   top: 5px;
//   background: rgba(0, 0, 0, 0.60);
// }

.category-modal-body {
  display: flex;
  align-items: flex-start;
  height: 521px;
  // overflow-y: auto;
  border-bottom: 1px solid rgba(0, 0, 0, 0.10);
}

.category-modal-sidebar {
  //: 320px;
  background: white;
  box-shadow: 2px 0px 13px rgba(0, 0, 0, 0.06);
//   border-right: 1px solid rgba(0, 0, 0, 0.10);
  display: flex;
  flex-direction: column;
}
.category-modal-sidebar:hover {
 background: rgba(0, 0, 0, 0.03); 
} 
.category-sidebar-item {
  padding: 12px 16px;
  // max-height: 64px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.10);
  display: flex;
  align-items: center;
  // gap: 8px;
  cursor: pointer;
} 

.category-item-content {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 4px;
}

.category-item-icon {
  width: 40px;
  height: 40px;
  position: relative;
  overflow: hidden;
}

 

.category-item-text {
  flex: 1;
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  //font-family: Inter;
  font-weight: 500;
  text-transform: capitalize;
  line-height: 17.50px;
}

.category-modal-middle {
  flex: 1;
  background: white;
  //box-shadow: 2px 0px 13px rgba(0, 0, 0, 0.06);
  // border-left: 1px solid rgba(0, 0, 0, 0.10);
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.category-modal-middle:hover {
  background: rgba(0, 0, 0, 0.03); 
}
.category-middle-item {
  padding: 4px 16px;
  min-height: 36px;
  max-height: 52px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item-active {
  background: rgba(0, 0, 0, 0.03); 
}

.category-middle-text {
  flex: 1;
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  //font-family: Inter;
  font-weight: 400;
  line-height: 18.20px;
  cursor: pointer;
}

.category-modal-right {
  flex: 1;
  // border-left: 1px solid rgba(0, 0, 0, 0.10);
  display: flex;
  flex-direction: column;

}
.category-modal-right:hover {
background: rgba(0, 0, 0, 0.03); 
}
.category-right-item {
  padding: 8px 16px;
  min-height: 36px;
  max-height: 52px;
  display: flex;
  align-items: center;
  gap: 4px;
  
}

.category-checkbox {
  width: 15px;
  height: 15px;
  position: relative;
  cursor: pointer;
}

// .category-checkbox::after {
//   content: '';
//   width: 15px;
//   height: 15px;
//   position: absolute;
//   left: 2.50px;
//   top: 2.50px;
//   background: rgba(0, 0, 0, 0.40);
// }

.category-right-text {
  flex: 1;
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  //
  font-weight: 400;
  line-height: 18.20px;
  cursor: pointer;
}

.category-right-hint {
  color: rgba(0, 0, 0, 0.40);
  font-size: 12px;
  font-style: italic;
  line-height: 15.60px;
}

.category-scrollbar {
  padding: 8px 4px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.category-scrollbar-track {
  width: 5px;
  height: 300px;
  background: #D9D9D9;
  border-radius: 5px;
}

.category-modal-footer {
  height: 72px;
  padding: 0 24px;
  display: flex;
  // justify-content: flex-end;
  align-items: center;
  gap: 16px;
  position: relative;
}

.category-confirm-btn {
  width: 220px;
  height: 48px;
  background: #E8340C;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  right: 20px;
}
.confirm-btn-disable{
  cursor: not-allowed !important;
  background: var(--On-Surface-40, rgba(0, 0, 0, 0.40)) !important;
}

.category-confirm-text {
  color: white;
  font-size: 14px;
  //font-family: Inter;
  font-weight: 700;
  line-height: 18.20px;
}
 
.btnOutDiv{
  width: 100%;
  justify-content: flex-end;
    align-items: center;
    /* gap: 16px; */
    display: inline-flex
;
    padding: 16px;
} 
.category-confirm-btn {
  width: 220px;
  height: 48px;
  background: #E8340C;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.category-confirm-text {
  color: white;
  font-size: 14px;
  //font-family: Inter;
  font-weight: 700;
  line-height: 18.20px;
}
//复选框颜色：

input[type=checkbox]{
     cursor: pointer;
     position: relative;
     width: 15px;
     height: 15px;
     font-size: 14px;
}

input[type=checkbox]::after{
        position: absolute; 
    width: 15px;
    height: 15px; 
    text-align: center; 
}
        
input[type=checkbox]:checked::after{
    content: "✔";
    font-size: 12px;
    // font-weight: bold;
    color: white;
    background: #E8340C;
}

</style>
 